import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Retention() {
  return (
    <ScaffoldPage
      title="Retention Policies"
      description="Configure data retention windows for different data types."
      breadcrumbs={buildBreadcrumbs('/settings/governance/retention')}
      plannedFeatures={[
        'Per-data-type retention windows (profiles, sessions, audit logs)',
        'Automatic data expiration and archival',
        'Retention policy templates for common regulations',
        'Compliance-driven minimum retention periods',
      ]}
      relatedPages={[
        { label: 'Storage Tiers', href: '/settings/governance/storage' },
        { label: 'Data Deletion', href: '/settings/governance/deletion' },
      ]}
    />
  )
}
